import styles from './text-split.module.scss';

type TextSplitProps = {
    grouping?: number;
    fromStart?: boolean;
    children:
        | string
        | number
        | null
        | undefined
        | (string | number | undefined | null)[];
};

export const TextSplit = ({
    children,
    grouping = 3,
    fromStart = false
}: TextSplitProps) => {
    const text =
        children instanceof Array
            ? children.join('')
            : (children?.toString() ?? '');

    const chunks =
        text.match(
            fromStart
                ? new RegExp(`.{1,${grouping}}`, 'g')
                : new RegExp(`.{1,${grouping}}(?=(.{${grouping}})*(?!.))`, 'g')
        ) ?? [];

    return (
        <>
            {chunks.map((chunk, index) => (
                <span key={index} className={styles.chunk}>
                    {chunk}
                </span>
            ))}
        </>
    );
};
